import { NgOptimizedImage } from '@angular/common';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TitleStrategy } from '@angular/router';
import { ToastrModule } from 'ngx-toastr';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { AppTitleStrategy } from './app-title.strategy';
import { BulkEntryComponent } from './components/bulk-entry/bulk-entry.component';
import { CostCenterFormFieldComponent } from './components/cost-center-form-field/cost-center-form-field.component';
import { CostCenterLookupComponent } from './components/cost-center-lookup/cost-center-lookup.component';
import { EquipmentComponent } from './components/equipment/equipment.component';
import { GridSwitchComponent } from './components/grid-switch/grid-switch.component';
import { LaborComponent } from './components/labor/labor.component';
import { ModalComponent } from './components/modal/modal.component';
import { ModalContentAboutComponent } from './components/modal/modal-content-about/modal-content-about.component';
import { ModalContentAboutTimesheetComponent } from './components/modal/modal-content-about-timesheet/modal-content-about-timesheet.component';
import { ModalContentConfirmAbandonComponent } from './components/modal/modal-content-confirm-abandon/modal-content-confirm-abandon.component';
import { ModalContentDeleteTimesheetComponent } from './components/modal/modal-content-delete-timesheet/modal-content-delete-timesheet.component';
import { ModalContentNeedHelpComponent } from './components/modal/modal-content-need-help/modal-content-need-help.component';
import { ModalContentSimpleDisplayComponent } from './components/modal/modal-content-simple-display/modal-content-simple-display.component';
import { NumericInputFieldComponent } from './components/numeric-input-field/numeric-input-field.component';
import { ProductionComponent } from './components/production/production.component';
import { ReadOnlyFieldComponent } from './components/read-only-field/read-only-field.component';
import { ReadOnlyTextComponent } from './components/read-only-text/read-only-text.component';
import { SummaryComponent } from './components/summary/summary.component';
import { ToastComponent } from './components/toast/toast.component';
import { HttpErrorInterceptor } from './interceptors/http-error.interceptor';
import { SetLoggingHeadersInterceptor } from './interceptors/set-logging-headers.interceptor';
import { MaterialModule } from './material.module';
import { ContractComponent } from './pages/contract/contract.component';
import { CrewEditComponent } from './pages/crew-edit/crew-edit.component';
import { EquipmentEditComponent } from './pages/equipment-edit/equipment-edit.component';
import { TimesheetComponent } from './pages/timesheet/timesheet.component';
import { ZeroTrimPipe } from './pipes/zero-trim.pipe';

@NgModule({
  declarations: [
    //Try to keep this array alphabetized
    AppComponent,
    BulkEntryComponent,
    ContractComponent,
    CostCenterFormFieldComponent,
    CostCenterLookupComponent,
    CrewEditComponent,
    EquipmentComponent,
    EquipmentEditComponent,
    GridSwitchComponent,
    LaborComponent,
    ModalComponent,
    ModalContentAboutComponent,
    ModalContentAboutTimesheetComponent,
    ModalContentConfirmAbandonComponent,
    ModalContentDeleteTimesheetComponent,
    ModalContentNeedHelpComponent,
    ModalContentSimpleDisplayComponent,
    NumericInputFieldComponent,
    ProductionComponent,
    ReadOnlyFieldComponent,
    ReadOnlyTextComponent,
    SummaryComponent,
    TimesheetComponent,
    ToastComponent,
    ZeroTrimPipe,
  ],
  bootstrap: [AppComponent],
  imports: [
    AppRoutingModule,
    BrowserAnimationsModule,
    BrowserModule,
    FormsModule,
    MaterialModule,
    NgOptimizedImage,
    ReactiveFormsModule,
    ToastrModule.forRoot({
      // Toastr: https://github.com/scttcper/ngx-toastr
      toastComponent: ToastComponent,
      positionClass: 'toast-bottom-right',
      closeButton: true,
      tapToDismiss: false,
      progressBar: true,
      preventDuplicates: true,
      disableTimeOut: false, //mouse over to stop the timer
      resetTimeoutOnDuplicate: true,
      enableHtml: true,
      timeOut: 8000,
      extendedTimeOut: 8000, //reset the timer back to the beginning after mousing over it
    }),
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: SetLoggingHeadersInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpErrorInterceptor,
      multi: true,
    },
    {
      provide: TitleStrategy,
      useClass: AppTitleStrategy,
    },
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
// eslint-disable-next-line @typescript-eslint/no-extraneous-class -- This rule is OK to disable here since a class is required and we don't have to do anything with it
export class AppModule {}
